import { render } from "./IpAddressesTab.vue?vue&type=template&id=4b7d6d8a&scoped=true"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js"

import "./IpAddressesTab.vue?vue&type=style&index=0&id=4b7d6d8a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7d6d8a"]])

export default __exports__